// removed by extract-text-webpack-plugin
module.exports = {"menuItem":"_2qt4H8Z","button":"_1xJ3tLR","circleImage":"_2e3YCj1","label":"_39II9oU","label__sale":"_1sIwZh0","label__bold":"_3G7NJJ1"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.css
// module chunks = client.sitechrome